import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import styles from './DishCard.module.css'
import { setQuantity, setStoplist } from '../../../api/Menu'
import { menuItemPatch } from '../../../redux/actions/Menu'
import { getDishImageUrl } from '../utils'
import { IconCheck, IconClose, IconMinus, IconPlus, IconReturn, IconSliders, IconStop, IconTrash } from '../icons'

const applyPatch = data => (data ? { stopped: data.stopped, quantity: data.quantity, quantity_left: data.quantity_left } : { stopped: false, quantity: null, quantity_left: null })

const DishCard = ({ dish, restId, date, onRequestDelete }) => {
  const dispatch = useDispatch()
  const [editing, setEditing] = useState(false)
  const [inputVal, setInputVal] = useState('')

  const patch = data => dispatch(menuItemPatch({ menuId: dish.id, patch: applyPatch(data) }))

  const stop = async () => {
    const response = await setStoplist(restId, dish.id, { date, stopped: true })
    patch(response.data.data)
  }

  const restore = async () => {
    const response = await setStoplist(restId, dish.id, { date, stopped: false })
    patch(response.data.data)
  }

  const applyQuantity = async quantity => {
    const response = await setQuantity(restId, dish.id, { date, quantity })
    patch(response.data.data)
  }

  const startEditing = () => {
    setInputVal(dish.quantity != null ? String(dish.quantity) : '')
    setEditing(true)
  }

  const confirmEditing = () => {
    const parsed = parseInt(inputVal, 10)
    if (!isNaN(parsed) && parsed >= 0) applyQuantity(parsed)
    setEditing(false)
  }

  const stepEditing = delta => {
    const next = (parseInt(inputVal, 10) || 0) + delta
    if (next >= 0) setInputVal(String(next))
  }

  const step = delta => {
    const next = (dish.quantity ?? 0) + delta
    if (next >= 0) applyQuantity(next)
  }

  const clearQuantity = () => applyQuantity(null)

  const stopped = !!dish.stopped
  const hasQuantity = dish.quantity != null

  return (
    <div className={`${styles.row} ${stopped ? styles.stopped : ''}`}>
      <img className={styles.image} src={getDishImageUrl(dish.image)} alt='' />
      <span className={styles.title}>{dish.title_ru}</span>

      <div className={styles.controls}>
      {stopped ? (
        <>
          <span className={styles.stoppedLabel}>В стоп-листе</span>
          <button className={styles.iconBtn} onClick={restore} title='Вернуть'>
            <IconReturn className={styles.returnIcon} />
          </button>
        </>
      ) : editing ? (
        <div className={styles.editor}>
          <button className={styles.stepBtn} onClick={() => stepEditing(-1)}>
            <IconMinus />
          </button>
          <input
            className={styles.editorInput}
            type='number'
            min='0'
            autoFocus
            value={inputVal}
            onChange={e => setInputVal(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && confirmEditing()}
            placeholder=''
          />
          <button className={styles.stepBtn} onClick={() => stepEditing(1)}>
            <IconPlus />
          </button>
          <button className={styles.iconBtn} onClick={confirmEditing} title='Подтвердить'>
            <IconCheck />
          </button>
          <button className={styles.iconBtn} onClick={() => setEditing(false)} title='Отмена'>
            <IconClose />
          </button>
        </div>
      ) : hasQuantity ? (
        <>
          <div className={styles.stepper}>
            <button className={styles.stepBtn} onClick={() => step(-1)}>
              <IconMinus />
            </button>
            <span className={styles.stepValue} onClick={startEditing}>
              {dish.quantity_left}
            </span>
            <button className={styles.stepBtn} onClick={() => step(1)}>
              <IconPlus />
            </button>
            <button className={styles.clearBtn} onClick={clearQuantity} title='Выключить счётчик'>
              <IconClose />
            </button>
          </div>
          <button className={`${styles.iconBtn} ${styles.stopBtn}`} onClick={stop} title='В стоп-лист'>
            <IconStop />
          </button>
        </>
      ) : (
        <>
          <button className={styles.iconBtn} onClick={startEditing} title='Указать количество'>
            <IconSliders />
          </button>
          <button className={`${styles.iconBtn} ${styles.stopBtn}`} onClick={stop} title='В стоп-лист'>
            <IconStop />
          </button>
        </>
      )}
      </div>

      <button className={styles.deleteBtn} onClick={() => onRequestDelete && onRequestDelete(dish)} title='Удалить из меню'>
        <IconTrash />
      </button>
    </div>
  )
}

export default DishCard
